import axios from "axios";
import { browserIcons, osIcons } from "../data/iconsEnum";
import { arbaeenServiceStationTypeEnum } from "../data/arbaeenServiceStationTypeEnum";
import { toast } from "react-toastify";
import { t } from "i18next";
import { AdmissionStepEnum } from "../data/AdmissionStepEnum";
import { config as configAe } from "./utils";
export const setDatePickerDate = (dater) => {
  let finalDate =
    dater?.getFullYear() +
    "-" +
    ("0" + (dater?.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + dater?.getDate()).slice(-2);

  return finalDate.toString();
};

export const downloadBase64 = (file) => {
  var a = document.createElement("a");
  a.href = `data:${file.ContentType};base64,` + file.Content;
  a.download = file.Name + file.Extension;
  a.click();
};
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
export const createUploadFileOBJ = (base64, file) => {
  let split = file.name.split(".");
  let extension = split[split.length - 1];
  var lastIndex = file.name.lastIndexOf(".");
  var nameWithoutExtension = file.name.slice(0, lastIndex);
  return {
    Name: nameWithoutExtension,
    Extension: `.${extension}`,
    ContentType: file.type,
    Content: base64,
  };
};
export const loadConfig = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_CONFIG);
    const data = await response.json();
    const specConfig = configAe.isAe ? data.AE : data.IR;
    const config = specConfig?.CUSTOMER || {};
    return config;
  } catch (error) {
    console.error("Failed to fetch config:", error);
  }
};

export const getFileExtension = (file) => {
  let split = file.name.split(".");
  let extension = `.${split[split.length - 1]}`;
  return extension;
};
export const convertUTC = (utc) => {
  const lang = localStorage.getItem("i18nextLng");
  var local = new Date(utc);
  switch (lang) {
    case "fa":
      return new Intl.DateTimeFormat("fa-IR").format(local);
    default:
      return new Intl.DateTimeFormat("en-US").format(local);
  }
};
export const todateTime = (date) => {
  let a = date?.split("T");
  a[0] = convertUTC(a[0]);
  a[1] = a[1]?.split(".")[0];
  return a?.reverse()?.join(" ");
};
export const checkBoolean = (value) => {
  return value.toLowerCase() === "true" ? true : false;
};
export const toastError = (error) => {
  toast.error(error, {
    position: toast.POSITION.BOTTOM_CENTER,
  });
};
export const findGeoLocation = (value) => {
  const splited = value.split(",");

  return splited[0] === "0" ? 0 : [Number(splited[1]), Number(splited[0])];
};
export const dateOfLogTable = (date) => {
  let a = date?.split("T");
  a[0] = convertUTC(a[0]);
  a[1] = a[1]?.split(".")[0];
  return a.reverse().join(" ");
};
export const IMEIvalidation = (imei) => {
  let arrayIMEI = [];
  let sum = 0;
  let multiply = 0;
  arrayIMEI = imei.split("");

  for (let i = 0; i < imei.length; i++) {
    if (i % 2 === 0) {
      sum += parseInt(arrayIMEI[i]);
    } else {
      multiply = parseInt(arrayIMEI[i]) * 2;
      if (multiply > 9) {
        sum += (multiply % 10) + Math.floor(multiply / 10);
      } else {
        sum += multiply;
      }
    }
  }

  if (sum % 10 === 0) {
    return true;
  } else {
    return false;
  }
};

export const SerialNumberValidation = (serial) => {
  if (serial?.length >= 10 && serial?.length <= 16) {
    return true;
  } else {
    return false;
  }
};

export const checkColorStep = (step) => {
  switch (step) {
    case "Registered":
      return "warning";
    case "Canceled":
      return "error";
    default:
      return "success";
  }
};
export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const getGeoFromIp = async (ip) => {
  var config = {
    method: "get",
    url: `http://ip-api.com/json/${ip}`,
    headers: {},
  };
  const result = await axios
    .request(config)
    .then(function (response) {
      const latLng = [response.data.lon, response.data.lat];
      return latLng;
    })
    .catch(function (error) {
      console.log(error);
    });
  return result;
};
export const findOsIcon = (value) => {
  const splited = value.split(" ");
  const os = splited[0].toLowerCase();
  return <div title={value}>{osIcons[os]}</div>;
};

export const findBrowserIcon = (value) => {
  const splited = value.split(" ");
  const browser = splited[0].toLowerCase();
  return <div title={value}>{browserIcons[browser]}</div>;
};

export const handleEqualLayer = (value, layers) => {
  let equal = false;

  for (let i = 0; i < layers.length; i++) {
    equal = equal || value === `unclustered-${layers[i]}-point`;
  }

  return equal;
};

export const handleMapBoxImageSwitcher = (item) => {
  switch (item) {
    case arbaeenServiceStationTypeEnum.Restaurant:
      return "Restaurant";

    case arbaeenServiceStationTypeEnum.RedCrescent:
      return "RedCrescent";

    case arbaeenServiceStationTypeEnum.Hospital:
      return "Hospital";
    case arbaeenServiceStationTypeEnum.WC:
      return "WC";
    case arbaeenServiceStationTypeEnum.Hotel:
      return "Hotel";

    default:
      break;
  }
};

export const createUploadFileFromBase64 = (base64, key) => {
  console.log("base64", base64);
  const yourBase64String = base64?.substring(base64?.indexOf(",") + 1);
  const kb = yourBase64String?.length;
  let ext = base64?.split("/")[1].split(";")[0];
  let type = base64?.split("/")[0].split(":")[1];
  return {
    Name: key || "default",
    Extension: ext,
    ContentType: type,
    Content: base64,
    Size: kb,
  };
};
export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};
export const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return value;
    }
  }
  return null;
};
export const downloadCSVCode = (data, title) => {
  var link = window.document.createElement("a");
  link.setAttribute(
    "href",
    "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data),
  );
  link.setAttribute("download", title);
  link.click();

  // let csvContent ="data:text/csv;charset=utf-8,,%EF%BB%BF";
  // csvContent += data + "\r\n";
  // var encodedUri = encodeURI(csvContent);
  // var link = document.createElement("a");
  // link.setAttribute("href", encodedUri);
  // link.setAttribute("download", title);
  // document.body.appendChild(link);
  // link.click();
};
export const noFileToast = () => {
  toast.info(t("noDataFound.table"), {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 2500,
  });
};

export const admissionSections = {
  Initial: [
    AdmissionStepEnum.Request,
    AdmissionStepEnum.WaitingForBike,
    AdmissionStepEnum.DeliveryToBike,
    AdmissionStepEnum.DeliveryToAgent,
    AdmissionStepEnum.DeliveryToCompany,
    AdmissionStepEnum.PostToAgent,
    AdmissionStepEnum.PostToCompany,
  ],
  Admission: [AdmissionStepEnum.Admission],
  Repair: [
    AdmissionStepEnum.AssignToInputQualityControl,
    AdmissionStepEnum.InputQualityControl,
    AdmissionStepEnum.AssignToRepair,
    AdmissionStepEnum.Repair,
    AdmissionStepEnum.AssignToOutputQualityControl,
    AdmissionStepEnum.OutputQualityControl,
    AdmissionStepEnum.AssignToReplacement,
    AdmissionStepEnum.Replacement,
    AdmissionStepEnum.AssignToReceiveInPerson,
    AdmissionStepEnum.ReceiveInPerson,
  ],
  ReadyToDeliver: [
    AdmissionStepEnum.FinancialApprovalCustomer,
    AdmissionStepEnum.FinancialApprovalAgent,
    AdmissionStepEnum.FinancialApprovalCompany,
    AdmissionStepEnum.Complete,
    AdmissionStepEnum.AssignToPostToBike,
    AdmissionStepEnum.ReadyToPostToBike,
    AdmissionStepEnum.ReadyToPostToAgent,
    AdmissionStepEnum.ReadyToPostToCustomer,
  ],
  Archive: [AdmissionStepEnum.Archive],
  Canceled: [AdmissionStepEnum.Canceled],
};

export const getSectionForAdmission = (step) => {
  for (const [sectionName, steps] of Object.entries(admissionSections)) {
    if (steps.includes(step)) {
      return sectionName;
    }
  }
  return "Initial";
};
export function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = resolve;
    document.body.appendChild(script);
  });
}
